import React, { PropTypes } from 'react';
import { SortableContainer } from 'react-sortable-hoc';

import Item, { itemShape, itemActions } from './Item';

import env from '../env';
import './List.css';

const propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(itemShape)).isRequired,
  isEditing: PropTypes.bool.isRequired,
  hideSelected: PropTypes.bool.isRequired,
  ...itemActions
};

class List extends React.Component {
  componentDidMount() {
    // iOS rubber banding fix
    // page scrolls instead of list when list is at top and user scrolls up or list is at bottom and user scrolls down
    // if page scrolls, the user cannot then scroll the ul until the page rubber banding has finished
    // if the user repeatedly scrolls the page when page is rubber banding, the ul scroll appears to be frozen
    // solution is to prevent the list from scrolling to the very top or bottom by reseting the scrollTop +/- 1 pixel
    if (env.iPhone) {
      this.listRef.scrollTop = 1;
      this.listRef.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    if (env.iPhone) {
      this.listRef.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll = ({ target }) => {
    const { scrollTop, scrollHeight, clientHeight } = target;

    if (scrollTop === 0) {
      target.scrollTop = 1;
    }

    if (scrollTop === scrollHeight - clientHeight) {
      target.scrollTop -= 1;
    }
  }

  getListRef = ref => this.listRef = ref

  render() {
    const { items, isEditing, hideSelected: twoClickSelect, onInsert, onRemove, onSelect, onEdit } = this.props;

    const renderItem = (item, index) => (
      <Item key={item.key} index={index} item={item} {...{ twoClickSelect, onInsert, onRemove, onSelect, onEdit }} />
    );

    return (
      <ul ref={this.getListRef} className={isEditing ? 'List List-editing' : 'List'}>
        {items.map(renderItem)}
      </ul>
    );
  }
}

List.propTypes = propTypes;

export default SortableContainer(List);



/** WEBPACK FOOTER **
 ** ./src/components/List.js
 **/